import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import TextField from "@material-ui/core/TextField";
import CardBody from "components/Card/CardBody.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalCrearUsuario from "./ModalAgregarUsuario";

// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalCargando from "../../../../components/Generales/ModalCargando";
import Globales from "utils/Globales";
import { Edit, Search, Close } from "@material-ui/icons";
import InputAdornment from "@material-ui/core/InputAdornment";

class CatUsuarios extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "",
      FiltrarNombres: "",
      ListaUsuarios: [],
      ListaUsuariosTemp: [],
      ListaModulos: [],
      UsuarioSeleccionado: {},
      Disabled: false,
      mensaje: "",
      br: false,
      show: false,
      cargando: false,
      colorNotificacion: "success",
      colorTableRow: "white",
      errorIDIdioma: false,
      entroEliminar: false,
      notificacion: false,
      showEditarUsuario: false,
      Total: 0,
      TotalSeleccionado: 0,
      Titulo: "Registrar un nuevo Usuario",
      IdNuevo: { _increment: "0", _machine: "0", _pid: "0", _timestamp: "0" },
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.entrar = true;
  }

  componentDidMount() {
    this.ListaGeneralUsuarios();
    this.ListaGeneralModulos();

  }

  async ListaGeneralUsuarios() {
    this.setState({ cargando: this.state.entroEliminar ? false : true });
    await fetch(Globales.Url + "Catalogos/Usuarios/ListaGeneralUsuarios", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data)
        if (data.error) {
          //Error en la respuesta
          this.setState({
            mensaje: data.mensaje,
            colorNotificacion: "danger",
            Activo: 1,
            cargando: false,
            entroEliminar: false,
          });
          this.showNotification();
        } else {
          if(data.Listausuarios.Usuarios.length > 1){
            this.setState({
              ListaUsuarios: data.Listausuarios.Usuarios,
              ListaUsuariosTemp: data.Listausuarios.Usuarios,
              cargando: false,
              entroEliminar: false,
            });
          }
          else{
            let aux =[];
            aux.push(data.Listausuarios.Usuarios);

            this.setState({
              ListaUsuarios: aux,
              ListaUsuariosTemp: aux,
              cargando: false,
              entroEliminar: false,
            });
          }
        }
      })
      .catch((err) => console.error("El error es", err));
  }

  async ListaGeneralModulos() {
    await fetch(Globales.Url + "Catalogos/Usuarios/ListaGeneralModulos", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          //Error en la respuesta
          this.setState({
            mensaje: data.mensaje,
            colorNotificacion: "danger",
            cargando: false,
            ListaModulos: [],
          });
          this.showNotification();
        } else {
          if (data.ListaModulos.Modulo.length > 1) {
            data.ListaModulos.Modulo.map(mod => {
              mod.Activo = false;
            })

            this.setState({
              ListaModulos: data.ListaModulos.Modulo,
              entroEliminar: false,
            });
          } else {
            data.ListaModulos.Modulo.Activo = false;

            let aux = [];
            aux.push(data.ListaModulos.Modulo)
            this.setState({
              ListaModulos: aux,
              entroEliminar: false,
            });
          }
        }
      })
      .catch((err) => console.error("El error es", err));
  }

  //Función para obtener el texto de los inputs
  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "FiltrarNombres") {
      const Dataorg = this.state.ListaUsuariosTemp;
      if (value) {
        const NuevaData = Dataorg.filter((Usuario) =>
          String(
            Usuario.Usuario +
              " - " +
              Usuario.Nombre +
              " " +
              (Usuario.ApellidoPaterno
                ? Usuario.ApellidoPaterno
                : Usuario.ApellidoMaterno
                ? Usuario.ApellidoMaterno
                : "") + " " + Usuario.Tipo
          )
            .toUpperCase()
            .includes(String(value).toUpperCase())
        );

        if(NuevaData.length === 0){
          this.setState({
            FiltrarNombres: value,
            ListaUsuarios: NuevaData,
            colorNotificacion: "danger",
            mensaje: "No se encontraron coincidencias",
          });
          this.showNotification();
        }
        else{
          this.setState({
            FiltrarNombres: value,
            ListaUsuarios: NuevaData,
          });
        }  
      } else {
        this.setState({
          FiltrarNombres: "",
          ListaUsuarios: [...Dataorg],
        });
      }
    }
  };

  eventoModalPregunta = (valor) => {
    this.setState({ show: false });
    if (valor) {
      this.eliminarUsuario(this.state.UsuarioSeleccionado);
    }
  };

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function() {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  eventoModalEliminar(e) {
    this.setState({ show: true, UsuarioSeleccionado: e });
    return;
  }

  eliminarUsuario(id) {
    fetch(Globales.Url + "Catalogos/Usuarios/EliminarInformacionUsuario", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
      body: JSON.stringify({ _id: id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          //Error al obtener los registros
          this.setState({ colorNotificacion: "danger" });
        } else {
          //Obtuvo los registros correctamente
          this.setState({ colorNotificacion: "success" });
        }
        this.setState({
          mensaje: data.mensaje,
          show: false,
          entroEliminar: true,
          FiltrarNombres: ""
        });
        this.showNotification();
        this.ListaGeneralUsuarios();
      });
  }

  RegresarMensaje = (mensaje) => {
    this.setState({ mensaje: mensaje, colorNotificacion: "success", FiltrarNombres: "" });
    this.showNotification();
    this.ListaGeneralUsuarios();
  };

  eventoEditarUsuario = (mensaje) => {
    //Cambiar valores por default
    this.state.ListaModulos.map(mod => {
      mod.Activo = false;
    })
    this.setState({ showEditarUsuario: false, op: 0, ListaModulos: this.state.ListaModulos });
    // if (mensaje != "esc") {
    //   this.setState({ mensaje: mensaje, colorNotificacion: "success" });
    //   this.showNotification();
    // }
  };

  openModalUsuario = (Tp, Id) => {
    this.setState({
      showEditarUsuario: true,
      Titulo: Tp ? "Registrar Usuario" : "Editar Usuario",
      op: Tp ? 0 : 1,
      UsuarioSeleccionado: Tp ? this.state.IdNuevo : Id,
    });
  };

  render() {
    const { classes } = this.props;

    let agregar;
    if (this.state.cargando == true) {
      agregar = (
        <ModalCargando Cuerpo={"Cargando"} show={this.state.cargando} />
      );
    }
    if (this.state.showEditarUsuario == true) {
      agregar = (
        <ModalCrearUsuario
          Titulo={this.state.Titulo}
          showEditarUsuario={this.state.showEditarUsuario}
          eventClick={this.eventoEditarUsuario}
          op={this.state.op}
          UsuarioSeleccionado={this.state.UsuarioSeleccionado}
          ListaModulos={this.state.ListaModulos}
          parentCallback={this.RegresarMensaje}
          ListaUsuariosTemp={this.state.ListaUsuariosTemp}
        />
      );
    }

    //console.log(this.state.ListaUsuarios)
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text={true}>
                <h4 className={classes.cardTitle}>Filtros</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      id="FiltrarNombres"
                      style={{ width: "23vw" }}
                      variant="outlined"
                      type="text"
                      size="small"
                      label="Nombre del usuario"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                        onChange: this.handleChange.bind(this),
                        value: this.state.FiltrarNombres,
                        name: "FiltrarNombres",
                        id: "FiltrarNombres",
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button
                      size="sm"
                      type="submit"
                      color="info"
                      round
                      className="pull-right"
                      onClick={() => this.openModalUsuario(1)}
                    >
                      Nuevo
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <h4 className="pull-left">Lista de Usuarios</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <h4
                      className="pull-right"
                      style={{ marginRight: "15px", marginTop: 0 }}
                    >
                      {this.state.ListaUsuarios.length} Usuario(s)
                    </h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                <div className="table-responsive text-nowrap table-wrapper-scroll-y">
                  <table className="table table-sm table-hover">
                    <thead>
                      <th>Usuario</th>
                      <th>Nombre completo</th>
                      <th>Tipo</th>
                      <th></th>
                    </thead>
                    <tbody>
                      {this.state.ListaUsuarios.map((Usuario, index) => {
                        return (
                          <tr key={Usuario._id + "-" + index}>
                            <td onClick={() =>this.openModalUsuario(null, Usuario)} style={{verticalAlign: "middle", cursor: "default"}}>{Usuario.Usuario}</td>
                            <td onClick={() =>this.openModalUsuario(null, Usuario)} style={{verticalAlign: "middle", cursor: "default"}}>{Usuario.Nombre + " " + (Usuario.ApellidoPaterno ? Usuario.ApellidoPaterno : Usuario.ApellidoMaterno ? Usuario.ApellidoMaterno: "")}</td>
                            <td onClick={() =>this.openModalUsuario(null, Usuario)} style={{verticalAlign: "middle", cursor: "default"}}>{Usuario.Tipo}</td>
                            <td style={{verticalAlign: "middle", cursor: "default"}}>
                            <Button
                                color="danger"
                                round
                                justIcon
                                className="pull-right"
                                size="sm"
                                onClick={() =>
                                  this.eventoModalEliminar(Usuario._id)
                                }
                              >
                                <Close />
                              </Button>
                              <Button
                                color="info"
                                round
                                justIcon
                                className="pull-right mr-2"
                                size="sm"
                                onClick={() =>
                                  this.openModalUsuario(null, Usuario)
                                }
                              >
                                <Edit />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Usuario"}
            Cuerpo={"¿Está seguro de dar de baja al usuario?"}
            show={this.state.show}
            eventClick={this.eventoModalPregunta}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(headerLinksStyle)(CatUsuarios);
